import { useSyncExternalStore } from "react";

export interface Crumb {
  label: string;
  to?: string;
}

/*
 * The breadcrumb trail a page asks for, handed to the bar under the header
 * (components/SiteBar), which draws it beside the search and language picker.
 * Pages render below the header, so the trail travels through this small
 * store rather than through props. Null means the page set none and the bar
 * works one out from the URL and the page's heading.
 */
let current: Crumb[] | null = null;
const listeners = new Set<() => void>();

export function setPageCrumbs(crumbs: Crumb[] | null) {
  current = crumbs;
  listeners.forEach((l) => l());
}

export function usePageCrumbs(): Crumb[] | null {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => current,
    () => null
  );
}
